import { render } from "./DahboardOtherRatios.vue?vue&type=template&id=78f00f9e"
import script from "./DahboardOtherRatios.vue?vue&type=script&lang=js"
export * from "./DahboardOtherRatios.vue?vue&type=script&lang=js"

import "./DahboardOtherRatios.vue?vue&type=style&index=0&id=78f00f9e&lang=scss"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__